import { Component } from '@angular/core';

import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { AnalyticsService } from 'app/shared/services/analytics.service';
import { NavigationIntentService } from 'app/shared/services/navigation-intent.service';

import { ButtonComponent } from '../../shared/components/button/button.component';
import { SvgIconComponent } from 'app/shared/components/svg-icon/svg-icon.component';

import { IButtonConfig } from '../../shared/interfaces/button.interfaces';
import { ISvgConfig } from 'app/shared/interfaces/svg.interfaces';

import { EButtonActionTypes, EButtonSizes, EButtonTypes } from '../../shared/enums/button.enums';
import { ETermsOfService } from '../../enums/terms-of-service.enums';
import { ESvgTypes } from 'app/shared/enums/svg.enums';

@Component({
  selector: 'stxt-age-verification',
  standalone: true,
  imports: [ButtonComponent, SvgIconComponent],
  templateUrl: './age-verification.component.html',
  styleUrl: './age-verification.component.scss'
})
export class AgeVerificationComponent {
  confirmAgeBtn: IButtonConfig = {
    text: 'Agree and Enter',
    fill: EButtonTypes.SecondaryFilled,
    buttonSize: EButtonSizes.Large
  };
  closeBtn: IButtonConfig = {
    text: 'I’m not 18+ years old, leave now',
    fill: EButtonTypes.Empty,
    buttonSize: EButtonSizes.Large
  };
  logo: ISvgConfig = {
    name: 'stxt_favicon_d2c',
    fill: ESvgTypes.None
  };
  logoText: ISvgConfig = {
    name: 'justsext',
    fill: ESvgTypes.None
  };

  public ETermsOfService = ETermsOfService;

  constructor(
    public activeModal: NgbActiveModal,
    public analyticsService: AnalyticsService,
    private readonly navigationIntentService: NavigationIntentService
  ) {}

  closeModal(): void {
    window.open('https://www.google.com/', '_self');
    this.analyticsService.click(
      this.closeBtn.text,
      'https://www.google.com/',
      'Home',
      EButtonActionTypes.AgeVerification,
      'https://www.google.com/'
    );
  }

  confirmAge(): void {
    this.activeModal.close();
    localStorage.setItem('ageVerified', String(true));
    this.navigationIntentService.navigateToIntentOrDefault();
    this.analyticsService.click(
      this.closeBtn.text,
      '',
      'Home',
      EButtonActionTypes.AgeVerification,
      ''
    );
  }
}
